module.exports = __webpack_public_path__ + "img/lotd_2.2f2cad37.png";